import axios from "axios";

export default {

    fetchNews(newscategoryId, perPage, page) {
        return axios.get('news?newscategory_id=' + newscategoryId + '&per-page=' + perPage + '&page=' + page)
            .then(response => {
                return response.data
            })
    },

}
